import React from "react";
import { useState } from "react";
import hygeineIcon from "../images/bubbles.png";

const ServicesCard = ({ name, role, services, icon }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div 
      className="team-card" 
      style={{ 
        background: '#004080', 
        color: '#e6f0fa', 
        borderRadius: '12px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: expanded ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
        position: 'relative',
        zIndex: expanded ? '1' : 'auto'
      }}
      onClick={() => setExpanded(!expanded)}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      <div className="team-card-content" style={{ position: 'relative' }}>
        <div style={{ padding: '16px' }}>
          <h2
            style={{
              fontSize: "1.3rem",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={icon}
              alt="icon"
              style={{ width: "20px", height: "20px" }}
            />
            {name}
          </h2>
          <p>{role}</p>
          <div 
            style={{
              display: 'flex',
              justifyContent: 'center',
              opacity: 0.8,
              marginTop: '4px',
              marginBottom: '8px'
            }}
          >
            <span
              style={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0)',
                transition: 'transform 0.3s ease',
                display: 'inline-block',
                fontSize: '0.7rem'
              }}
            >
              ▼
            </span>
          </div>
        </div>
        <div style={{
          overflow: 'hidden',
          maxHeight: expanded ? '500px' : '0',
          opacity: expanded ? 1 : 0,
          transition: 'all 0.3s ease',
          background: '#004080',
          borderRadius: '0 0 12px 12px',
        }}>
          <ul style={{ 
            padding: '16px 16px 16px 48px',
            margin: 0,
            listStyle: 'disc outside',
            fontSize: '0.875rem',
            lineHeight: '1.25rem'
          }}>
          {services.map((service, index) => (
            <li 
              key={index}
              style={{
                transition: `all 0.3s ease-in-out ${index * 0.1}s`,
                opacity: 1,
                transform: 'translateY(0)',
                marginBottom: '0.25rem'
              }}
            >
              {service}
            </li>
          ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ServicesCard;